<div class="filterField" [class.showing]="isShowing">
	<mat-form-field class="full-width-form" color="accent" [subscriptSizing]="'dynamic'">
		<mat-label>{{ T.SHARED_BASIC_ADMINISTRATION_TABLE_FILTER | translate }}</mat-label>

		@switch (filterInputType) {
			@case ("FreeText") {
				<input #inputElement matInput [formControl]="filterInputFormControl" placeholder="" />
			}
			@case ("Checkbox") {
				<mat-checkbox #inputElement [formControl]="filterInputFormControl" appStopPropagation />
			}
			@case ("Date") {
				<input
					#inputElement
					matInput
					[matDatepicker]="picker"
					[formControl]="filterInputFormControl"
					placeholder=""
					(focus)="handleFocus($event)"
					(blur)="handleFocus(null)"
				/>
				<div class="datePickerAnchor">
					<mat-datepicker-toggle matSuffix [for]="picker" />
				</div>
				<mat-datepicker #picker />
			}
			@case ("Select") {
				<mat-select #inputElement [formControl]="filterInputFormControl" placeholder="">
					@for (option of selectableOptions; track option) {
						<mat-option [value]="option.value">{{ option.translationToken | translate }}</mat-option>
					}
				</mat-select>
			}
		}

		<mat-select
			name="filterColumn"
			class="filterColumnSelect"
			[(ngModel)]="searchFilterColumn"
			(selectionChange)="onColumnChange($event.value)"
			(click)="handleColumnSelectClick($event)"
		>
			@for (column of searchableColumns; track column) {
				<mat-option [value]="column.value">{{ column.displayName | translate }}</mat-option>
			}
		</mat-select>
		@if (filterInputFormControl.hasError("matDatepickerParse")) {
			<mat-error>
				{{ T.SHARED_BASIC_ADMINISTRATION_TABLE_INVALID_DATE | translate }}
			</mat-error>
		}
	</mat-form-field>
</div>
